import {Pipe, PipeTransform} from "@angular/core";

type FileSizeUnit = "B" | "KB" | "MB" | "GB";

/**
 * Pipe to convert file size in bytes to human readable format.
 */
@Pipe({
	name: "fileSize",
	standalone: false,
})
export class FileSizePipe implements PipeTransform {
	transform(value: number, unit: FileSizeUnit = "MB", fractionDigits: number = 0): string {
		if (value < 0) {
			return "0";
		}

		const units = ["B", "KB", "MB", "GB"];
		const index = units.indexOf(unit);
		if (index === -1) {
			return value.toString();
		}

		const base = 1000;
		const size = value / Math.pow(base, index);
		return `${size.toFixed(fractionDigits)} ${unit}`;
	}
}
